import axios from 'axios';
import { UpdateVehicleInfoDto, VehicleInfoDto } from '@/features/deviceInformation/deviceInformation.dto';
import { ServiceResponse } from '@/OptimusRoutes/interfaces';

type Service = {
	get: (deviceId: number) => Promise<ServiceResponse<VehicleInfoDto>>;
	update: (deviceId: number, deviceInfo: UpdateVehicleInfoDto) => Promise<ServiceResponse<VehicleInfoDto>>;
};

const get = async (deviceId: number): Promise<ServiceResponse<VehicleInfoDto>> => {
	const { data } = await axios.get<ServiceResponse<VehicleInfoDto>>(`/v2/devices/${deviceId}/vehicle`);
	return data;
};

const update = async (deviceId: number, deviceInfo: UpdateVehicleInfoDto): Promise<ServiceResponse<VehicleInfoDto>> => {
	const { data } = await axios.patch<ServiceResponse<VehicleInfoDto>>(`/v2/devices/${deviceId}/vehicle`, deviceInfo);
	return data;
};

// TO-DO convert to class service
const DeviceInformationService: Service = {
	get,
	update,
};

export default DeviceInformationService;
